<template>
  <div>
    <div v-if="isLoading" class="shimmer h-5 w-1/3 rounded-md" />
    <div v-else>
      <button
        type="button"
        class="flex items-center space-x-1"
        @click="bottomSheet.show(bottomSheetName)"
      >
        <slot name="trigger" />
        <ChevronIcon class="text-text-positive-primary h-4 w-4 rotate-90" />
      </button>
    </div>
    <CitySelectBottomSheet
      :name="bottomSheetName"
      :title="$t('main.cities.localDeparture')"
      :search-placeholder="$t('main.cities.departurePlaceholder')"
      :fetch-cities="query => fetchCities(query, onlyKzCities)"
      :min-query-length="0"
      :popular-routes="searchCities.lib.getDeparturePopularRoutes()"
      search-history-prefix="free-avia-hot-offers-city-from"
      @onCitySelect="handleCitySelect"
    >
      <template #subDirectionIcon>
        <img src="@/assets/images/plane.svg" alt="" width="24" height="24" />
      </template>
    </CitySelectBottomSheet>
  </div>
</template>

<script setup lang="ts">
  import { controllerModel, searchCities, type MappedLocation } from 'shared';
  import { CitySelectBottomSheet } from 'freedom-shared';

  import { fetchCities } from '@/shared/api';

  import ChevronIcon from '@/assets/images/chevron-arrow-16x16.svg?component';

  const props = defineProps<{
    isLoading: boolean;
    bottomSheetName: string;
    onlyKzCities: boolean;
  }>();

  const emit = defineEmits<{
    onCitySelect: [cityCode: MappedLocation];
  }>();

  const bottomSheet = controllerModel.useBottomSheet();

  const handleCitySelect = (city: MappedLocation) => {
    emit('onCitySelect', city);
    bottomSheet.hide(props.bottomSheetName);
  };
</script>
